import { Search, Target, Network, MessagesSquare } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const PILLARS = [
    { icon: Search, title: "DIAGNÓSTICO", text: "Entendemos como sua empresa está sendo apresentada hoje." },
    { icon: Target, title: "ESTRATÉGIA", text: "Identificamos o que precisa ser ajustado para melhorar sua presença digital." },
    { icon: Network, title: "ESTRUTURA", text: "Organizamos Instagram, WhatsApp e os principais pontos de contato com seu cliente." },
    { icon: MessagesSquare, title: "COMUNICAÇÃO", text: "Criamos uma comunicação mais clara, profissional e alinhada ao seu negócio." },
];

const Solution = () => (
    <section data-testid="solution-section" className="relative py-24 sm:py-32 bg-[#0a0a0e] border-y border-line/60">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_50%_40%_at_80%_20%,rgba(212,175,55,0.06),transparent_70%)]" />
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHeading
                eyebrow="A abordagem SETH"
                title={
                    <>
                        A SETH coloca <span className="text-gold-grad">ordem</span> na sua presença
                        digital.
                    </>
                }
                text="Analisamos o que seu negócio já possui, identificamos os pontos que estão dificultando sua comunicação e estruturamos uma presença digital mais clara, profissional e preparada para vender."
            />

            <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {PILLARS.map((p, i) => (
                    <Reveal key={p.title} delay={0.08 * i} className="h-full">
                        <article
                            data-testid={`solution-pillar-${p.title.toLowerCase()}`}
                            className="card-hover group h-full rounded-2xl border border-line bg-card p-7 flex flex-col gap-14"
                        >
                            <div className="flex items-center justify-between">
                                <p.icon
                                    size={22}
                                    strokeWidth={1.5}
                                    className="text-gold transition-transform duration-500 group-hover:scale-110"
                                />
                                <span className="font-mono2 text-xs text-gold/60">
                                    /{String(i + 1).padStart(2, "0")}
                                </span>
                            </div>
                            <div className="flex flex-col gap-3">
                                <span className="rule-gold w-8 transition-all duration-500 group-hover:w-full" />
                                <h3 className="font-display text-xl font-bold tracking-wide text-ink">
                                    {p.title}
                                </h3>
                                <p className="text-sm text-ink2 leading-relaxed">{p.text}</p>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Solution;
